import classes from './home.module.css'
import heroDrum from '../images/heroDrum.svg'
import heroText from '../images/heroText.svg'
import smallAvi from '../images/smallAvi.svg'
import guitar from '../images/toppng.com-black-guitar-208x600.png'
import holdingHand from '../images/holdingHand.png'
import { CiSearch } from "react-icons/ci";
import { useState } from 'react'
import xin from '../images/109c15d0c8efb698501dbea560466627.jpg'
import hype from '../images/drum-set-stage-spotlight.jpg'
import beta from '../images/diverse-people-with-music-instruments.jpg'
import { moneyFormat } from '../helpers/moneyFormatter'
import { FaStar } from 'react-icons/fa'
import { formatDateHeader } from '../helpers/formatDateHeader'




const reasons = [
    { name: 'Wide Variety of Bands', text: 'From rock to classical, find bands for every genre and style.', },
    { name: 'Seamless Booking Process', text: 'Effortlessly book the perfect band in minutes.', },
    { name: 'Verified Reviews', text: 'Make informed decisions with ratings and testimonials from past customers.', },
    { name: 'Support You Can Rely On', text: '24/7 support to ensure your event is stress-free.', },
]

export function HeroSection() {
    return (
        <div className={classes.heroContainer}>
            <img src={heroDrum} alt='logo' className={classes.hero_drum} />

            <div>
                <img src={heroText} alt='hero text' className={classes.hero_text} />
                <p className={classes.heroSubtext}>Use your favorite bands for any event</p>
                <p className={classes.heroSubtextMoreDetails}>Handpicked talent to make your event truly extraordinary, delivering captivating performances that leave a lasting and unforgettable impression.</p>


                <div className={classes.bottom}>
                    <img src={smallAvi} alt='3 small avi' className={classes.small_avi} />
                    <div className={classes.scrollingInstruction}>
                        <div className={classes.thin_line} />
                        <p className={classes.rotatedText}>Keep Scrolling</p>
                    </div>
                    <div className={classes.closingHero} />
                </div>
            </div>
        </div>
    );
}

export function NextSection() {
    return (
        <div className={classes.nextSectionContainer}>
            <p className={classes.whyChooseUsText}>Why Choose Us?</p>
            <div className={classes.whyCardsGrouped}>
                <img src={guitar} alt='guitar' className={classes.guitar} />

                {
                    reasons?.map((reason, index) => (
                        <div style={index === 1 || index === 2 ? { background: '#fff', color: '#4467C3' } : {}} className={classes.whyCard} key={index}>
                            <p className={classes.reasonName}>{reason.name}</p>
                            <p className={classes.reasonText}>{reason.text}</p>
                        </div>
                    ))
                }
            </div>

            <ThirdSection />
            <PopularBrand />
            <TestimonialSection />



        </div>
    )
}


export function ThirdSection() {
    return (
        <div className={classes.thirdSectionContainer}>
            <p className={classes.thirdSectionContainerText}>An online calendar, task management, contact management and a tour management solution for everyone who deals with bookings. Easy to use on desktop, tablet and mobile devices.</p>
        </div>
    )
}



export function PopularBrand() {
    const filters = ['latest', 'popular', 'premium']
    const [selectedFilter, setSelectedFilter] = useState(filters[0])

    const bands = [
        { image: 'https://ticket-global-frontend-he6s.vercel.app/static/media/front-view-woman-having-fun-outdoors%20(1).b7097fa8dc5e0e7352d3.jpg', name: 'Party Poppers', price: '3' },
        { image: 'https://ticket-global-frontend-he6s.vercel.app/static/media/man-with-dreads-jamaica.25a031c2c7d9a5221746.jpg', name: 'ArtFelt Band', price: '2' },
        { image: xin, name: 'XI Jing Group', price: '3' },
        { image: hype, name: 'Hype Squad', price: '3' },
        { image: beta, name: 'Beta People', price: '3' },
    ]

    return (
        <div className={classes.popularBrands}>
            <div className={classes.popularBrandsSubContainer}>
                <p className={classes.popularBrandTitle}>POPULAR PROFESSIONAL BANDS</p>
                <p className={classes.popularBrandSubTitle}>Choose a brand according to your preference and book as soon as possible</p>

                <div className={classes['Frame-16']}>
                    <div className={classes['Frame-15']}>
                        <select className={classes.select}>
                            <option>All</option>
                        </select>
                    </div>

                    <div className={classes.searchInputContainer}>
                        <input placeholder='Search band' className={classes.select} type='text' />

                        <CiSearch className={classes.searchIcon} />
                    </div>
                </div>

                <div className={classes.filterGrouped}>
                    {filters?.map((filter, index) => (
                        <p style={selectedFilter === filter ? { color: '#fbbb8c', fontWeight: 'bold' } : {}} key={index} className={classes.filterName}>{filter}</p>
                    ))}
                </div>

                <div className={classes.bandCards}>
                    {
                        bands?.map((band, index) => (
                            <div className={classes.bandCard} key={index}>
                                <img className={classes.bandImage} src={band?.image} alt={band?.name} />

                                <div className={classes.bandTexts}>
                                    <p className={classes.bandName}>{band.name}</p>
                                    <p className={classes.bandPrice}>starting at {moneyFormat.format(band.price)} per hour</p>
                                </div>

                                <button className={classes.bookNowBtn}>
                                    Book Now
                                </button>
                            </div>

                        ))
                    }
                </div>

                <button className={`${classes.bookNowBtn} ${classes.getTheAppBtnDown}`}>
                    Get The App
                </button>

            </div>
        </div>
    )
}

export function TestimonialSection() {

    const metrics = [
        { name: 'Rating on AppStore', count: '4.8' },
        { name: 'Active Users', count: '100k+' },
        { name: 'Downloads', count: '500k+' },
        { name: 'Customer Satisfaction', count: '95%' },

    ]

    const testimonies = [
        {
            name: "Alex Carter",
            image: "https://img.freepik.com/free-photo/vertical-shot-attractive-african-american-man-posing-smiling_181624-15027.jpg?uid=R89822399&ga=GA1.1.1971203961.1738401306&semt=ais_hybrid",
            testimony: "Booking a band for my wedding was seamless! The process was quick, and the band delivered an amazing performance. Highly recommend!",
            stars: 5
        },
        {
            name: "Samantha Lee",
            image: "https://img.freepik.com/free-photo/black-man-city_1157-18144.jpg?uid=R89822399&ga=GA1.1.1971203961.1738401306&semt=ais_hybrid",
            testimony: "Incredible experience! Found a fantastic jazz band for my corporate event. The interface made booking effortless.",
            stars: 5
        },
        {
            name: "Jason Moore",
            image: "https://img.freepik.com/free-photo/african-american-student-walking-street-talking-phone_1303-12696.jpg?uid=R89822399&ga=GA1.1.1971203961.1738401306&semt=ais_hybrid",
            testimony: "Great selection of bands, and the customer support was very responsive. My birthday party was a hit thanks to this platform!",
            stars: 4
        },
        {
            name: "Melissa Rivera",
            image: "https://img.freepik.com/free-photo/stylish-black-girl_1157-15544.jpg?uid=R89822399&ga=GA1.1.1971203961.1738401306&semt=ais_hybrid",
            testimony: "I booked a rock band for my festival, and they absolutely crushed it! Will definitely use Book My Band again!",
            stars: 5
        },
        {
            name: "Cynthia O’Neil",
            image: "https://img.freepik.com/free-photo/close-up-portrait-fashionable-black-woman-with-stylish-afro-hairs-posing-outdoor-urban-background-wearing-black-sunglasses-hat-white-earrings-trendy-accessories-perfect-smile_273443-142.jpg?uid=R89822399&ga=GA1.1.1971203961.1738401306&semt=ais_hybrid",
            testimony: "The band I booked was professional, on time, and their music was fantastic. The payment process was also smooth.",
            stars: 4
        }
    ];


    return (
        <div className={classes.testimonialSection}>
            <p className={classes['Satisfied-Customers-Are-Our-Best-Ads']}>Satisfied Customers Are Our Best Ads.</p>
            <div className={classes.metrics}>
                {
                    metrics?.map((metric, index) => (
                        <div className={classes.metricsSubGroup} key={index}>
                            <div>
                                <p className={classes.metricCount}>{metric.count}</p>
                                <p className={classes.metricName}>{metric.name}</p>
                            </div>

                            {
                                index !== metrics.length - 1 &&
                                <div className={classes.metricDivider} />
                            }

                        </div>
                    ))
                }
            </div>


            <div className={classes.testimonials}>
                {
                    testimonies?.map((testimony, index) => (
                        <div className={classes.testimonyContainer} key={index}>
                            <p className={classes.bigQuotation}>“</p>
                            <p className={classes.testimonyWords}>{testimony?.testimony}</p>

                            <div className={classes.userTestifyingGroup}>
                                <img src={testimony.image} alt='testimony' className={classes.testimonyImage} />
                                <div>
                                    <p>{testimony.name}</p>

                                    <div>
                                        {
                                            Array.from({ length: testimony.stars })?.map((star, index) => (
                                                <FaStar className={classes.star} />
                                            ))
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>

            <LatestEvents />

        </div>
    )
}


export function LatestEvents() {

    const recentEvents = [
        {
            title: "C.E.O EME Records and former boss to Wizkid, Bankole Wellington, popularly known as Banky W, and Adesua Etomi",
            subText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis a urna at odio tincidunt posuere. Curabitur ac risus ut elit cursus cursus. Morbi id odio nec ligula feugiat consectetur. Praesent lacinia sapien id tortor fermentum, a volutpat justo scelerisque. Integer non orci vitae odio aliquet euismod. Donec tincidunt facilisis mauris, vel dapibus nunc scelerisque in.",
            date: "February 5, 2025",
            image: "https://images.hive.blog/0x0/https://files.peakd.com/file/peakd-hive/kodeblaccc/fh0ikCYX-BJS_4985.jpg"
        },
        {
            title: "AfroBeats Explosion 2025 – A Night of Rhythms and Energy",
            subText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce auctor libero id urna consequat, at pharetra nulla luctus. Vestibulum hendrerit est ac velit dignissim, non rhoncus dolor tincidunt. Etiam sed eros vel arcu pellentesque efficitur at nec dui. Duis ultricies orci a ligula tincidunt, nec faucibus dolor condimentum. Nam in nulla vitae nisl tincidunt fermentum ut sit amet orci.",
            date: "January 20, 2025",
            image: "https://miro.medium.com/v2/resize:fit:1400/1*mFW9rU1PmTdu7VJTPV7sGQ.jpeg"
        },
        {
            title: "Jazz Under the Stars – An Exclusive Evening with the Finest Jazz Bands",
            subText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse vel tellus eu arcu fermentum vulputate. Sed venenatis ligula ut erat pellentesque, sit amet pharetra felis convallis. Curabitur ac arcu nec justo sollicitudin lobortis. Nullam suscipit elit eu mauris tristique, ut tincidunt massa tempus. Maecenas tincidunt mi vel libero venenatis, ac feugiat libero scelerisque.",
            date: "December 15, 2024",
            image: "https://art635-gallery.storage.googleapis.com/wp-content/uploads/2018/04/07102214/Owambe-The-Party-Joshua-Davies-Davies-Joshua.jpg"
        },
        {
            title: "Lagos Rock Fest – Bringing the Best Rock Bands to the Stage",
            subText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus dictum mi vel purus bibendum tincidunt. Aliquam vitae tortor ac nulla tincidunt suscipit. Integer vel justo sit amet risus eleifend cursus. Proin euismod erat non ligula eleifend, eget tempus nisi pellentesque. Sed elementum felis et nunc vulputate, vel tincidunt velit vehicula. Pellentesque at nulla lacus.",
            date: "November 10, 2024",
            image: "https://theyesng.com/wp-content/uploads/2020/07/Owambe.jpg"
        },
        {
            title: "Highlife Revival – Celebrating Classic African Highlife Music",
            subText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin accumsan felis eu sem laoreet feugiat. Donec fringilla, purus nec volutpat pharetra, neque felis suscipit metus, eu tempor velit sem in ex. Nulla malesuada ligula nec felis tempor, sit amet dictum elit euismod. Nam auctor ex in sapien congue vestibulum. Cras luctus mauris vel odio tincidunt, a ultrices elit dignissim.",
            date: "October 5, 2024",
            image: "https://i.ytimg.com/vi/QkDPoBE4EuU/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLAn01VP-j4wVpCDUJjkZMzKRSiPNA"
        }
    ];




    return (
        <div className={classes.latestEventSection}>
            <p className={classes['Satisfied-Customers-Are-Our-Best-Ads']}>Latest Events Covered.</p>

            <div className={classes.latestEvents}>
                <div className={classes['Frame-31']}>
                    <img src={recentEvents[0]?.image} alt='' className={classes.firstLatestEventImage} />
                    <p className={classes.recentEventDate}>{formatDateHeader(recentEvents[0]?.date)}</p>
                    <p className={classes.recentEventTitle}>{recentEvents[0]?.title}</p>
                    <p className={classes.recentEventSubText}>{recentEvents[0]?.subText}</p>
                </div>

                <div className={classes.smallRecentEventsGroup}>
                    {
                        recentEvents.slice(1, recentEvents.length)?.map((recentEvent, index) => (
                            <div className={classes.individualRecentEvent} key={index}>
                                <img src={recentEvent?.image} alt='' className={`${classes.firstLatestEventImage} ${classes.recentEventImage}`} />
                                <div className={classes.individualRecentEventSubCon}>
                                    <p className={classes.recentEventDate}>{formatDateHeader(recentEvent?.date)}</p>
                                    <p className={`${classes.recentEventTitle} ${classes.individualRecentEvent}`}>{recentEvent?.title}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>

            </div>

        </div>
    )
}